module.exports = __webpack_public_path__ + "zvetseni-prsou_6_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_6_after.jpg
// module id = 1365
// module chunks = 0